import * as React from "react"
import {Box, Typography} from "@mui/material"

import {ChipBlock, CommonIconButton, ListCountries, ListRetailers} from "../../@components";
import {NotAllowedBlock} from "@components";

export default function scopeColumn() {
    return {
        name: "countries", label: 'Scope',
        options: {
            filter: false,
            setCellProps: () => ({ sx: { maxWidth: 400 } }),
            customBodyRowRenderLite: (value, row) => {

                const countriesToShow = value?.length > 0 ? value.slice(0, 2) : value
                const retailersToShow = row.sites?.length > 0 ? row.sites.slice(0, 2) : row.sites
                const brandsToShow = row.brands?.length > 0 ? row.brands.slice(0, 2) : row.brands
                const skuGroupsToShow = row.skuGroups?.length > 0 ? row.skuGroups.slice(0, 5) : row.skuGroups

                return <Box sx={{ display: "flex", flexDirection: "column", alignItems: 'center', gap: 0.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Countries:</Typography>
                        { !value?.length && <Typography variant="body2 sx={{ ml: 1 }}">All</Typography> }
                        <ListCountries countries={countriesToShow} />
                        { value?.length > 2 && <CommonIconButton remaining={value?.length - 2} />}
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Retailers:</Typography>
                        { !row.sites?.length && <Typography variant="body2" sx={{ ml: 1 }}>All</Typography> }
                        <ListRetailers retailers={retailersToShow} />
                        { row.sites?.length > 2 && <CommonIconButton remaining={row.sites?.length - 2} />}
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Brands:</Typography>
                        { !row.brands?.length && <Typography variant="body2" sx={{ ml: 1 }}>All</Typography> }
                        <ChipBlock listElements={brandsToShow} />
                        { row.brands?.length > 2 && <CommonIconButton remaining={row.brands?.length - 2} />}
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Sku Groups:</Typography>
                        { !row.skuGroups?.length && <Typography sx={{ ml: 1 }}><NotAllowedBlock /></Typography> }
                        <ChipBlock listElements={skuGroupsToShow} />
                        { row.skuGroups?.length > 2 && <CommonIconButton remaining={row.skuGroups?.length - 2} />}
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Num Skus:</Typography>
                        <Typography sx={{ ml: 1 }}>
                            {row.skus?.length ? row.skus?.length : <NotAllowedBlock />}
                        </Typography>
                    </Box>

                </Box>
            }
        }
    }
}